export default "__VITE_ASSET__71EooT$C__"